import * as React from 'react';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import Breadcrumbs from 'react-router-breadcrumbs';
import { IStore } from 'redux/IStore';
import { createArticleTag } from 'modules/magazine/article/managearticletag';
import { showModal, closeModal } from 'redux/modules/modal';
import { IUserPreferences } from 'models/user/userpreferences';
import * as c from 'models/constants';
import { IArticleTagDomainValue } from 'models/magazine/article/articletagdomainvalue';
import { IModalAction } from 'models/modal';
import { IManageArticleTagAction, IArticleTagManageDomainValue } from 'models/magazine/article/managearticletag';
import { IUserLanguage } from 'models/user/userlanguage';
import { IManagePollAction } from 'models/polls/managepoll';
import { IPoll } from 'models/polls/poll';
import { getUserCard } from 'redux/modules/user/usercard';
import { IProductCardDataAction } from 'models/product/productcard';
import renderIcon from 'helpers/renderIcon';

require('./style.scss');

interface IProps {
	userPreferences?: IUserPreferences;
	onShowUserContextMenuClicked?: any;
	routes?: any;
	routing?: any;
	userLanguage?: IUserLanguage;
	baseUrlClient?: string;
	createArticleTag?: (articleTag: IArticleTagManageDomainValue) => IManageArticleTagAction;
	submitCreatePoll?: (poll: IPoll) => IManagePollAction;
	t?: (key: string) => string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	openNewPollForm?: () => IManagePollAction;
	getUserCard?: (id: string) => IProductCardDataAction;
	closeSideBarCallback?: () => void;
}

@connect(
	(state: IStore) => ({
		routing: state.routing,
		userPreferences: state.userPreferences,
		userLanguage: state.userLanguage,
		baseUrlClient: state.fetchDefault.baseUrlClient,
	}),
	(dispatch) => ({
		createArticleTag: (tag: IArticleTagDomainValue) => dispatch(createArticleTag(tag)),
		showModal: (modalType: string, modalProps: any) => dispatch(showModal(modalType, modalProps)),
		closeModal: () => dispatch(closeModal()),
		getUserCard: (id: string) => dispatch(getUserCard(id)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminHeader extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.openAddArticleTag = this.openAddArticleTag.bind(this);
		this.createArticleTag = this.createArticleTag.bind(this);
		this.openAddPoll = this.openAddPoll.bind(this);
	}

	private createArticleTag(tag: IArticleTagDomainValue) {
		this.props.createArticleTag(tag);
	}

	private openAddArticleTag() {
		this.props.showModal('ManageArticleTag', {
			createArticleTag: this.createArticleTag,
			closeModal: this.props.closeModal,
			showModal: this.props.showModal,
			showHeaderCloseButton: true,
		});
	}

	private openAddPoll() {
		this.props.showModal('ManagePoll', {
			closeModal: this.props.closeModal,
			showModal: this.props.showModal,
			showHeaderCloseButton: true,
		});
	}
	public render() {
		const breadcrumbsResolver = (key) => t(key);
		const { t, routes, routing } = this.props;

		let addButton: JSX.Element = null;
		if (routing.locationBeforeTransitions) {
			if (routing.locationBeforeTransitions.pathname.includes('/admin/articles')) {
				addButton = (
					<Link to="/admin/articles/newarticle">
						<img src={require('containers/Html/icons/ico_plus.svg')} className="icon" />
						{t('AdminHeader_AddArticle')}
					</Link>
				);
			} else if (routing.locationBeforeTransitions.pathname.includes('/admin/magazine/pages')) {
				addButton = (
					<Link to="/admin/magazine/pages/new">
						<img src={require('containers/Html/icons/ico_plus.svg')} className="icon" />
						{t('AdminHeader_AddPage')}
					</Link>
				);
			} else if (routing.locationBeforeTransitions.pathname.includes('/admin/tags')) {
				addButton = (
					<a href="#" onClick={this.openAddArticleTag}>
						<img src={require('containers/Html/icons/ico_plus.svg')} className="icon" />
						{t('AdminHeader_AddTag')}
					</a>
				);
			} else if (routing.locationBeforeTransitions.pathname.includes('/admin/portal/pages')) {
				addButton = (
					<Link to="/admin/portal/pages/new">
						<img src={require('containers/Html/icons/ico_plus.svg')} className="icon" />
						{t('AdminHeader_AddPage')}
					</Link>
				);
			} else if (routing.locationBeforeTransitions.pathname.includes('/admin/polls')) {
				addButton = (
					<a href="#" onClick={this.openAddPoll}>
						<img src={require('containers/Html/icons/ico_plus.svg')} className="icon" />
						{t('AdminHeader_AddPoll')}
					</a>
				);
			}
		}

		return (
			<header className="adminNavigationHolder portalNavigationHolder">
				<div className="top-part">
					<a className="logo" href="/">
						<img
							src={require('containers/Html/images/logo/glossiq-white.svg')}
							className="icon"
							style={{ width: '128px' }}
						/>
					</a>
					<div className="right-content">
						<div className="admin-add">{addButton}</div>
						<div className="mobile">
							{renderIcon('hamby0', undefined, undefined, undefined, this.props.closeSideBarCallback)}
						</div>
					</div>
				</div>
				<div className="bottom-part">
					<Breadcrumbs
						className="breadcrumbs-holder"
						routes={routes}
						resolver={breadcrumbsResolver}
						createSeparator={'/'}
					/>
				</div>
			</header>
		);
	}
}

export { AdminHeader };
